<div class="container">
  <div class="row">
    <div class="col-lg-6 col-12">
      <h5 class="account-title mt-0 mb-2">{{ 'account.details.title' | translate }}</h5>
      <fgb-account-details></fgb-account-details>
    </div>
    <div class="col-lg-6 col-12 mt-lg-0 mt-4" *notInProductCode="productcode.SingleGameBuyer">
      <fgb-my-representative></fgb-my-representative>
    </div>
  </div>
</div>
